import { sortingMethods } from '../../../../../../constants/table';
import CustomCell from '../../../../../../components/Table/CustomCell';

export const detailsHeadings = [
  {
    title: 'Device Name',
    name: 'name',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterManagedInstallersUnaffectedDevices',
    sortingCellField: 'Name',
    sortFieldName: 'OrderQuery',
    width: '33%',
  },
  {
    title: 'lastSeen',
    name: 'lastSeen',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterManagedInstallersUnaffectedDevices',
    sortingCellField: 'LastSeen',
    sortFieldName: 'OrderQuery',
    width: '33%',
  },
];

export const columnsOrderDetails = [
  { name: 'name', styles: { wordBreak: 'break-word' } },
  { name: 'lastSeen', styles: { wordBreak: 'break-word' } },
];

export const sidebarList = [
];